import { render, staticRenderFns } from "./EmbedNewDocument.vue?vue&type=template&id=8ce0e514&"
import script from "./EmbedNewDocument.vue?vue&type=script&lang=js&"
export * from "./EmbedNewDocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports